import React, { FunctionComponent } from 'react'

import { TPaymentStatus } from '../../../../types'
import { paymentInfoObject } from '../settings/paymentStatusMessageProperties'

import {
  PaymentStatusMessageContainer,
  PaymentStatusMessageIcon,
  PaymentStatusMessageText,
  PaymentStatusMessageWrapper,
} from './style'

interface IProps {
  paymentStatus: TPaymentStatus
}

export const PaymentStatusMessage: FunctionComponent<IProps> = ({
  paymentStatus,
}) => {
  if (!paymentStatus) {
    return null
  }
  const paymentStatusInfo = paymentInfoObject[paymentStatus]

  return (
    <PaymentStatusMessageContainer paymentStatus={paymentStatus}>
      <PaymentStatusMessageWrapper>
        <span>
          <PaymentStatusMessageIcon
            paymentStatus={paymentStatus}
            icon={paymentStatusInfo.icon}
          />
        </span>
        <PaymentStatusMessageText paymentStatus={paymentStatus}>
          {paymentStatusInfo.message}
        </PaymentStatusMessageText>
      </PaymentStatusMessageWrapper>
    </PaymentStatusMessageContainer>
  )
}
